import React, { useState } from 'react';
import { supabase } from '../supabase';
import './ratingPopup.css';

import bookTicket from '../assets/imgs/bookTicket.png';

const RatingPopup = ({ onClose }) => {
  const [rating, setRating] = useState(0);
  const [message, setMessage] = useState('');

  const submitFeedback = async () => {
    if (!rating) return;

    const { error } = await supabase.from('mobile_feedback').insert([
      {
        rating,
        message,
        page: 'events',
      },
    ]);

    if (error) {
      console.error('Feedback failed:', error.message);
      return;
    }

    onClose();
  };

  return (
    <div className="ratingOverlay">
      <div className="ratingCard">
        <button className="ratingClose" onClick={onClose}>
          ×
        </button>

        <img src={bookTicket} alt="Book and ticket" className="ratingImage" />

        <h2>How was your CIBF experience?</h2>
        <p>Your feedback helps us improve the app</p>

        <div className="starsRow">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              onClick={() => setRating(star)}
              className={rating >= star ? 'activeStar' : ''}
            >
              ☆
            </button>
          ))}
        </div>

        <label>Tell us more (optional)</label>

        <textarea
          placeholder="What did you love? What could we improve?"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button className="submitFeedbackBtn" onClick={submitFeedback}>
          Submit feedback
        </button>
      </div>
    </div>
  );
};

export default RatingPopup;